exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clothing-admin__section {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.clothing-admin__section-title {\r\n  font-size: 1.25rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.clothing-admin__section-note {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.clothing-admin__field {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.clothing-admin__field label {\r\n  display: block;\r\n  font-weight: 600;\r\n  margin-bottom: 0.35rem;\r\n}\r\n\r\n.clothing-admin__loader {\r\n  min-height: 4rem;\r\n}\r\n\r\n.clothing-admin__empty {\r\n  padding-top: 1rem;\r\n}\r\n\r\n.clothing-admin__actions {\r\n  white-space: nowrap;\r\n}\r\n\r\n.clothing-admin__actions .btn + .btn {\r\n  margin-left: 0.5rem;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/admin/clothing/clothing-admin-personal-norms.component.css
// module id = ../../../../../src/app/content-page/admin/clothing/clothing-admin-personal-norms.component.css
// module chunks = main